import React from 'react'
import TablePagination from 'components/TablePagination'
import { textLabels } from 'utils/constants/textLabels'
import { IconButton, Tooltip } from '@mui/material'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'

const generateOptions = (filename, actions) => {
  const options = {
    filterType: 'checkbox',
    selectableRows: 'none',
    responsive: 'vertical',
    filter: false,
    search: true,
    searchPlaceholder: 'Pesquisar',
    searchOpen: true,
    print: false,
    download: true,
    downloadOptions: {
      filename: filename,
      filterOptions: {
        useDisplayedRowsOnly: false,
        useDisplayedColumnsOnly: false,
      },
    },
    viewColumns: true,
    pagination: true,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 20, 30],
    textLabels,
    customToolbar: () => {
      return addKeyToObjectsArray(actions).map((action) => {
        return (
          <Tooltip key={action.key} title={action.tooltip_text}>
            <IconButton onClick={action.callback}>
              <action.icon />
            </IconButton>
          </Tooltip>
        )
      })
    },
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
      return (
        <TablePagination
          count={count}
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          component="div"
          options={options}
        />
      )
    },
  }
  return options
}

export default generateOptions
